import React, { useState, useEffect, useContext } from "react";
import { LiabilityReport } from "./LiabilityDashboardComponents/LiabilityReport";
import { LiabilityInfo } from "./LiabilityDashboardComponents/LiabilityInfo";
import { CreditTable } from "./LiabilityDashboardComponents/CreditTable";
import { LiabilityTable } from "./LiabilityDashboardComponents/LiabilityTable";
import { useHistory } from "react-router-dom";
import "./LiabilityDashboard.css";
import FETCH from "../../utils/fetch";
import {
  setRefreshTime,
  setRefreshTimeAsset,
} from "../../redux/slices/itemsSlice";
import { useDispatch } from "react-redux";
import DEATH_API from "../../apis/death.api";
import swal from "sweetalert";
import { MODULE_API } from "../../apis";
import moment from "moment";
import { FutureLoan } from "./LiabilityDashboardComponents/FutureLoan";
import { GlobalLoaderContext } from "../../utils/GlobalLoaderContext";
import ModalVideo from "../ModuleVideos/ModalVideo";
export const LiabilityDashboard = () => {
  const history = useHistory();
  const { runWithLoader } = useContext(GlobalLoaderContext);
  const [sharedState, setSharedState] = useState(false);
  const dispatch = useDispatch();
  // Function to update the shared state
  const updateSharedState = (newState) => {
    setSharedState(newState);
  };
  const [loading, setLoading] = useState(false);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [cachedData, setCachedData] = useState({});
  // state for creditTable
  const [liabilitiesCredit, setLiabilitesCredit] = useState([]);
  const [creditRows, setCreditRows] = useState([]);
  const [creditLimit, setCreditLimit] = useState([]);
  const [creditBalance, setCreditBalance] = useState([]);
  const [futureLoan, setFutureLoan] = useState([]);
  const [liabilityCreditHigherValue, setLiabilityCreditHigherValue] = useState(
    []
  );

  // state for Liablityinfo
  const [total, setTotal] = useState(null);

  const [totalNoCredit, setTotalNoCredit] = useState(null);
  // Pagination state
  const [currentPageCredit, setCurrentCreditPage] = useState(1);
  const [totalCreditPages, setTotalCreditPages] = useState(1);
  const [cachedDataCredit, setCachedDataCredit] = useState({});

  const [totalAmount, setTotalAmount] = useState(0);
  const [totalMonthly, setTotalMonthly] = useState(0);
  const [totalAmountAll, setTotalAmountAll] = useState(0);
  const [creditCount, setCreditCount] = useState(0);
  const [totalCountAndBalance, setTotalCountAndBalance] = useState(null);
  const [totalCreditLimit, setTotalCreditLimit] = useState(0);
  const [averageInterestRate, setAverageInterestRate] = useState(null);
  const [highestARP, setHighestARP] = useState(0);
  const [highestLoan, setHighestLoan] = useState(0);
  const [highestMonthly, setHighestMonthly] = useState(0);
  const [totalMonthDiff, setTotalMonthDiff] = useState(0);
  const [newLiabilitySum, setNewLiabilitySum] = useState();
  const [newCreditSum, setNewCreditSum] = useState();
  const moduleStateMapping = {
    Student: "student",
    Auto: "auto",
    "Real Estates": "realEstate",
  };
  console.log("===>totalAmountAll===>", JSON.stringify(totalAmountAll));

  // states for Liablity Report
  const [totalLoan, setTotalLoan] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [totalBalanceUpdated, setTotalBalanceUpdated] = useState(0);
  const [syncPayload, setSyncPayload] = useState([]);
  const [clientBanks, setClientBanks] = useState(null);
  const [liabilitiesAll, setLiabilitesAll] = useState([]);
  const getAssetsList = async (page) => {
    console.log("here in cached data", cachedData, page);
    if (cachedData && cachedData[page]) {
      // Use cached data
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Liability&page=${page}&limit=10&clientId=${ID}`
            : `?module=Liability&page=${page}&limit=10`,
        body: {},
      });
      setLoading(false);

      if (datares && datares.records) {
        // Cache the data for the current page
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getCreditList = async (page) => {
    console.log("here in cached data", cachedData, page);
    if (cachedDataCredit && cachedDataCredit[page]) {
      // Use cached data
      setLoading(false);
      updateStateWithCreditData(cachedDataCredit[page]);
      return;
    }
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Credit&page=${page}&limit=10&clientId=${ID}`
            : `?module=Credit&page=${page}&limit=10`,
        body: {},
      });
      setLoading(false);

      if (datares && datares.records) {
        // Cache the data for the current page
        setCachedDataCredit((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithCreditData(datares);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getFutureLoan = async () => {
    try {
      setLoading(true);
      let datares = await MODULE_API.fetchFutureLoans(1);
      console.log("datares fultytt", datares);
      if (datares && datares.records) {
        setFutureLoan(datares.records);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getBankDetails = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBankDetails();
      setSyncPayload([]);
      let obj = [];
      let bankData = {};
      if (data && data.data) {
        const newArray = data.data.map((account) => {
          return {
            accountId: account.accountId,
            accountName: `${account.accountName}`,
            bankName: account.bankName,
            subType: account.subType,
            accountNumber: account.mask,
            accountTitle: `${account.accountName} ${account.mask}`,
            balance: account.balance,
          };
        });
        setClientBanks([
          ...newArray,
          {
            accountId: 1234,
            accountName: "cash",
            bankName: "devbank",
            subType: "debsubtype",
            accountNumber: 1122,
            accountTitle: "Cash",
            balance: 1111,
          },
        ]);

        data.data.forEach((item) => {
          if (!bankData[item.bankName]) {
            bankData[item.bankName] = [];
          }
          bankData[item.bankName].push({
            ...item,
            bankName: item.bankName,
            mask: item.mask,
          });
        });
        data.data.map((item, idx) => {
          obj.push({
            bankName: item.bankName,
            mask: item.mask,
            accessToken: item.accessToken,
          });
        });
      }
      setSyncPayload((prevState) => [...prevState, ...obj]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const updateStateWithData = (datares) => {
    // Reset states
    setLiabilitesCredit([]);
    setTotalLoan(0);
    setTotalBalance(0);
    setTotalBalanceUpdated(0);
    setCreditCount(0);
    setTotalCountAndBalance(null);
    setTotalCreditLimit(0);
    setAverageInterestRate(null);
    setLiabilitesAll([]);
    setTotalAmountAll(0);
    setTotalMonthly(0);
    setTotalAmount(0);
    setTotal(0);

    let highestInitialLoanAmount = 0;
    let highestInterestRate = 0;
    let highestMonthlyPayment = 0;
    let totalMonthsDifference = 0;
    let totalCards = 0;
    let totalMonthsDifferenceLiability = 0;
    let totalCardsLiability = 0;

    if (datares && datares.records) {
      const liabilities = datares.records.filter(
        (record) => record.subType === "Liability"
      );
      setLiabilitesAll(liabilities);

      liabilities.forEach((item) => {
        const currentDate = new Date();
        if (
          item["Maturity Date"] &&
          new Date(item["Maturity Date"]) > currentDate
        ) {
          const creditCardOpenDate = item["Start Date"]
            ? new Date(item["Start Date"])
            : new Date();
          const TodaysDate = new Date();
          const diffYears =
            TodaysDate.getFullYear() - creditCardOpenDate.getFullYear();
          const diffMonths =
            diffYears * 12 +
            (TodaysDate.getMonth() - creditCardOpenDate.getMonth());

          totalCardsLiability += 1;
          totalMonthsDifferenceLiability += diffMonths;
        }
        setLiabilitesCredit((prevState) => [...prevState, item]);
        // setTotalLoan(
        //   (prevState) => prevState + (+item["Initial Loan Amount"] || 0)
        // );

        const moduleKey = moduleStateMapping[item.module] || "other";

        if (
          ((item["Loan Balance"] && item["Loan Balance"]) ||
            item["Initial Loan Amount"]) > 0 &&
          item.subType === "Liability"
        ) {
          setTotalAmountAll((prevState) => ({
            ...prevState,
            [moduleKey]:
              (prevState[moduleKey] || 0) +
              parseFloat(
                item["Loan Balance"] || +item["Initial Loan Amount"] || 0
              ),
            other:
              moduleKey === "other"
                ? (prevState.other || 0) +
                  parseFloat(
                    item["Loan Balance"] || +item["Initial Loan Amount"] || 0
                  )
                : prevState.other || 0,
          }));
        }

        if (item["Monthly Payment"] && item["Monthly Payment"] > 0) {
          setTotalMonthly(
            (prevState) => prevState + (+item["Monthly Payment"] || 0)
          );
        }

        if (
          (item["Credit Balance"] && item["Credit Balance"] > 0) ||
          ((item["Loan Balance"] && +item["Loan Balance"]) ||
            (item["Initial Loan Amount"] && item["Initial Loan Amount"])) > 0
        ) {
          setTotalAmount(
            (prevState) =>
              prevState +
              (item["Credit Balance"] || 0) +
              (+item["Loan Balance"] || item["Initial Loan Amount"] || 0)
          );
        }

        if (
          item["Initial Loan Amount"] &&
          item["Initial Loan Amount"] > highestInitialLoanAmount
        ) {
          highestInitialLoanAmount =
            item["Loan Balance"] || item["Initial Loan Amount"];
        }
        if (
          item["Interest Rate"] &&
          item["Interest Rate"] > highestInterestRate
        ) {
          highestInterestRate = item["Interest Rate"];
        }
        if (
          item["Interest Rate (or APR%)"] &&
          item["Interest Rate (or APR%)"] > highestInterestRate
        ) {
          highestInterestRate = item["Interest Rate (or APR%)"];
        }
        if (
          item["Monthly Payment"] &&
          +item["Monthly Payment"] > highestMonthlyPayment
        ) {
          highestMonthlyPayment = +item["Monthly Payment"];
        }
      });
    }

    if (datares && datares.pagination) {
      setTotal(datares.pagination.total);
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }

    const cardsDifference = totalMonthsDifference / totalCards;
    const liabilityDifference =
      totalMonthsDifferenceLiability / totalCardsLiability;
    const averageAge = ((cardsDifference + liabilityDifference) / 2).toFixed(2);

    setTotalMonthDiff(averageAge);
    setHighestARP(highestInterestRate);
    setHighestLoan(highestInitialLoanAmount);
    setHighestMonthly(highestMonthlyPayment);
  };
  const updateStateWithCreditData = (datares) => {
    setCreditRows([]);
    if (datares && datares.records) {
      setCreditRows(datares.records);
      const totalMonthlyPayment = datares.records.reduce((sum, card) => {
        const payment = +card["Monthly Payment"] || 0;
        return sum + payment;
      }, 0);
      setTotalMonthly((prev) => prev + totalMonthlyPayment);
    }

    if (datares && datares.pagination) {
      setTotalNoCredit(datares.pagination.total);
      setTotalCreditPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };

  // with out unique modules
  const nicknames =
    creditRows && creditRows.map((card) => card["Nickname of Credit"] || null);
  useEffect(() => {
    // this is for Bar chart
    const creditBalances =
      creditRows && creditRows.map((card) => card["Credit Balance"] || 0);

    // for not showing neagtive chart
    const creditLimits =
      creditRows &&
      creditRows.map((card) => {
        const creditLimit = +card["Credit Limit"] || 0;
        const creditBalance = +card["Credit Balance"] || 0;
        const remainingCredit = creditLimit - creditBalance;
        return remainingCredit < 0 ? 0 : remainingCredit;
      });
    console.log("nicknames", nicknames, creditBalances, creditLimits);
    setCreditBalance(creditBalances);
    setCreditLimit(creditLimits);
  }, [creditRows]);

  useEffect(() => {
    getAssetsList(currentPage);
    if (!clientBanks) {
      getBankDetails();
    }
  }, [sharedState, currentPage]);

  useEffect(() => {
    getCreditList(currentPageCredit);
  }, [sharedState, currentPageCredit]);

  const getAssetsListAfterDelete = async (page) => {
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Liability&page=${page}&limit=10&clientId=${ID}`
            : `?module=Liability&page=${page}&limit=10`,
        body: {},
      });
      setLoading(false);

      if (datares && datares.records) {
        // Cache the data for the current page
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      } else {
        updateStateWithData([]);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getCreditListAfterDelete = async (page) => {
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Credit&page=${page}&limit=10&clientId=${ID}`
            : `?module=Credit&page=${page}&limit=10`,
        body: {},
      });
      setLoading(false);

      if (datares && datares.records) {
        // Cache the data for the current page
        setCachedDataCredit((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithCreditData(datares);
      } else {
        updateStateWithCreditData([]);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const refreshModule = async () => {
    try {
      setLoading(true);
      if (syncPayload && syncPayload.length > 0) {
        const refreshData = await DEATH_API.refreshBanksData(
          syncPayload && { accounts: syncPayload }
        );
      }
      const response = await DEATH_API.refreshLiability();
      const assetResponse = await MODULE_API.refreshAssetModule();

      console.log("response refresf", response);
      if (response && response.status === 200) {
        dispatch(
          setRefreshTime(
            response.updatedAt && response.updatedAt.updatedAt
              ? response.updatedAt.updatedAt
              : new Date()
          )
        );
      }
      if (
        assetResponse &&
        assetResponse.status === 200 &&
        assetResponse.updatedAt &&
        assetResponse.updatedAt
      ) {
        dispatch(setRefreshTimeAsset(assetResponse.updatedAt));
      }
      if (response && response.status === "ERROR") {
        // swal("Oops!",response.message,"error");
        swal({
          title: "Please Upgrade for a complete experience.",
          text: "Your level of subscription only allows for three Refreshes per day.",
          icon: "warning",
          type: "warning",
          buttons: {
            upgrade: {
              text: "Upgrade",
              value: "upgrade",
              visible: true,
            },
            ok: {
              text: "Ok",
              value: "ok",
              visible: true,
            },
          },
        }).then((value) => {
          console.log("Button value clicked:", value); // Debugging line to show the value
          switch (value) {
            case "upgrade":
              console.log("calling upgrade");
              updatePayment();
              break;

            case "ok":
              console.log("calling ok");
              break;

            default:
              console.log("No action taken");
              break;
          }
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  useEffect(() => {
    console.log("calling shared state");
    setCachedData({});
    // getAssetsListAfterDelete(1);
    getAllAfterDelete();
  }, [sharedState]);

  const getAllAfterDelete = async () => {
    await getAssetsListAfterDelete(1);
    getCreditListAfterDelete(1);
    await getAll();
  };

  const updatePayment = () => {
    history.push("/payment");
  };

  const getDebt = async (startDate, endDate) => {
    try {
      setLoading(true);
      setTotalBalanceUpdated(0);
      let data = await MODULE_API.getDebt(startDate, endDate);

      if (data && data.data) {
        setTotalBalanceUpdated(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getLiabilitySum = async () => {
    try {
      setLoading(true);
      setTotalLoan(0);
      let data = await MODULE_API.fetchLiabilitySum("Liability");
      if (data && data.sum) {
        setTotalLoan(data.sum);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getCreditSum = async () => {
    try {
      setLoading(true);
      setTotalBalance(0);
      setCreditCount(0);
      setTotalCreditLimit(0);
      let data = await MODULE_API.fetchLiabilitySum("Credit");
      if (data && data.sum) {
        setTotalBalance(data.sum);
        setCreditCount(data.moduleCount);
        setTotalCreditLimit(data.creditLimitSum);

      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  // const getLiabilityCreditSum = async () => {
  //   try {
  //     setLoading(true);
  //     // setTotalBalance(0);
  //     let data = await MODULE_API.fetchLiabilityCreditSum("Credit");
  //     console.log('credit-----------',data)
  //     let data1 = await MODULE_API.fetchLiabilityCreditSum("Liability");
  //     console.log('liability-----------',data1)
  //     if (data && data.sum) {
  //       // setTotalBalance(data.sum);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.log(error);
  //   }
  // };
  const getLiabilityCreditHigherValue = async () => {
    try {
      setLoading(true);
      // setTotalBalance(0);
      let data = await MODULE_API.fetchLiabilityCreditHigherValue();
      console.log("dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", data);
      if (data && data.result && data.result.length > 0) {
        // setTotalBalance(data.sum);
        const highestLoanBalance= data.amotizaionResult && data.amotizaionResult[0] && data.amotizaionResult[0]["max_balance"] || 0;
        setLiabilityCreditHigherValue({...data.result[0],highestLoanBalance:highestLoanBalance});
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getLiabilityCreditSum = async () => {
    try {
      setLoading(true);

      const [creditRes, liabilityRes] = await Promise.all([
        MODULE_API.fetchLiabilityCreditSum("Credit"),
        MODULE_API.fetchLiabilityCreditSum("Liability"),
      ]);

      setNewCreditSum(creditRes);
      if (creditRes != null) {
      }

      setNewLiabilitySum(liabilityRes);
      if (liabilityRes != null) {
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const callFilter = async (startDate, endDate) => {
    await getDebt(startDate, endDate);
  };
  const getAll = async () => {
    await runWithLoader(
      async () => {
        await getFutureLoan();
        await getLiabilitySum();
        await getCreditSum();
        await getLiabilityCreditSum();
        await getLiabilityCreditHigherValue();
      },
      () => {
        // 👇 This runs only if global loader actually shows after 4s
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    const date = moment();
    const startDate = date.startOf("month").format("YYYY-MM-DD");
    const endDate = date.endOf("month").format("YYYY-MM-DD");
    // callFilter(startDate, endDate);
    // getAll();
  }, []);

  return (
    <div className="liabilityMain">
      <ModalVideo module="Liabilities & Credit" autoOpen={true} />
      <div className="liabilitycreate">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <button
            className="addbuttonLiablity"
            onClick={() => {
              history.push("/debt-payOff");
            }}
          >
            {" "}
            + Add Debt Payoff
          </button>

          <button
            className="addbuttonLiablity"
            onClick={() => {
              history.push("/liabilities_credit_new");
            }}
          >
            {" "}
            + Add Liability
          </button>
        </div>
      </div>
      <div className="liabilityMainReport">
        <LiabilityReport
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          totalLoan={totalLoan && totalLoan}
          totalBalance={totalBalance && totalBalance}
          liabilitiesCredit={liabilitiesAll && liabilitiesAll}
          loading={loading}
          totalBalanceUpdated={totalBalanceUpdated}
        />
      </div>
      <div className="liablityInfoMain">
        <LiabilityInfo
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          total={total && total}
          totalAmount={totalAmount && totalAmount}
          totalMonthly={totalMonthly && totalMonthly}
          totalAmountAll={totalAmountAll && totalAmountAll}
          creditCount={creditCount && creditCount}
          totalCountAndBalance={totalCountAndBalance && totalCountAndBalance}
          totalCreditLimit={totalCreditLimit && totalCreditLimit}
          averageInterestRate={averageInterestRate && averageInterestRate}
          highestARP={highestARP && highestARP}
          highestLoan={highestLoan && highestLoan}
          highestMonthly={highestMonthly && highestMonthly}
          totalMonthDiff={totalMonthDiff && totalMonthDiff}
          loading={loading}
          totalLoan={totalLoan && totalLoan}
          totalBalance={totalBalance && totalBalance}
          newCreditSum={newCreditSum}
          newLiabilitySum={newLiabilitySum}
          creditRows={creditRows && creditRows}
          totalNoCredit={totalNoCredit && totalNoCredit}
          setLiabilityCreditHigherValue={setLiabilityCreditHigherValue}
          liabilityCreditHigherValue={liabilityCreditHigherValue}
        />
      </div>
      <div className="creditMainTag">
        <CreditTable
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          creditBalance={creditBalance && creditBalance}
          creditRows={creditRows && creditRows}
          uniqueModules={nicknames && nicknames}
          creditLimit={creditLimit && creditLimit}
          liabilitiesCredit={liabilitiesCredit && liabilitiesCredit}
          loading={loading}
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          refreshModule={refreshModule}
        />
      </div>
      <div className="liabilityTableCard">
        <LiabilityTable
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          creditRows={creditRows && creditRows}
          loading={loading}
          totalPages={totalCreditPages}
          currentPage={currentPageCredit}
          setCurrentPage={setCurrentCreditPage}
          refreshModule={refreshModule}
        />
      </div>
      <div className="liabilityTableCard">
        <FutureLoan
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          futureLoans={futureLoan && futureLoan}
          loading={loading}
        />
      </div>
    </div>
  );
};
